export default __webpack_public_path__ + "static/media/auth-new-intro-2.113a5554.svg";